import axios from 'axios';
import {
  POST_REGISTER_VALIDATE_REQUEST,
  POST_REGISTER_VALIDATE_SUCCESS,
  POST_REGISTER_VALIDATE_FAILURE,
  POST_REGISTER_REQUEST,
  POST_REGISTER_SUCCESS,
  POST_REGISTER_FAILURE
} from 'Store/constants';
import { getChannel } from 'Utils/channel';
import errorMessage from 'Store/actions/errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const postRegisterValidate = formData => dispatch => {
  return new Promise(async (resolve, reject) => {
    try {

      dispatch({
        type: POST_REGISTER_VALIDATE_REQUEST
      });

      const res = await axios({
        url: `${API_GATEWAY}/users/register/verify`,
        method: 'post',
        data: formData,
        headers: {
          channel: getChannel()
        }
      });

      dispatch({
        type: POST_REGISTER_VALIDATE_SUCCESS,
        payload: res.data
      });
      resolve();
    } catch (e) {

      dispatch({
        type: POST_REGISTER_VALIDATE_FAILURE,
        payload: e.response && e.response.data || errorMessage
      });
      reject(e);
    }
  });
};

export const postRegister = formData => async dispatch => {
  try {

    dispatch({
      type: POST_REGISTER_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/users/register/v2`,
      method: 'post',
      data: formData,
      headers: {
        channel: getChannel()
      }
    });

    if (formData?.referenceCode) {
      localStorage.setItem('loginWithReference', formData?.referenceCode);
      localStorage.setItem('referencesPage', 'register');
    }

    dispatch({
      type: POST_REGISTER_SUCCESS,
      payload: res.data,
      userAllowPermission: formData?.userAllowPermission,
      yearOfBirth: formData?.birthDate?.year,
    });


  } catch (e) {

    dispatch({
      type: POST_REGISTER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
